
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Ban, Zap, AlertTriangle } from 'lucide-react';
import { Bike } from '@/services/types';

interface BikeStatusIndicatorProps {
  bike: Bike;
}

export const BikeStatusIndicator: React.FC<BikeStatusIndicatorProps> = ({ bike }) => {
  const indicators = [];

  // Индикатор блокировки движения
  if (bike.movement_blocked) {
    indicators.push(
      <Badge 
        key="blocked" 
        variant="destructive" 
        className="flex items-center gap-1"
      >
        <Ban className="h-3 w-3" />
        Заблокирован
      </Badge>
    );
  }

  // Индикатор ограничения скорости
  if (bike.speed_limit && bike.speed_limit > 0) {
    indicators.push(
      <Badge 
        key="speed-limit" 
        variant="outline" 
        className="flex items-center gap-1 border-orange-500 text-orange-700"
      >
        <Zap className="h-3 w-3" />
        {bike.speed_limit} км/ч
      </Badge>
    );
  }

  // Индикатор низкого заряда батареи (используем любое из доступных полей батареи)
  const batteryLevel = (bike as any).battery_level || (bike as any).battery_percentage;
  if (batteryLevel && batteryLevel < 20) {
    indicators.push(
      <Badge 
        key="low-battery" 
        variant="outline" 
        className="flex items-center gap-1 border-red-500 text-red-700"
      >
        <AlertTriangle className="h-3 w-3" />
        Низкий заряд
      </Badge>
    );
  }

  if (indicators.length === 0) {
    return (
      <Badge variant="outline" className="text-green-700 border-green-500">
        Активен
      </Badge>
    );
  }

  return (
    <div className="flex flex-wrap gap-1">
      {indicators}
    </div>
  );
};
